export default __webpack_public_path__ + "static/media/Oval.54e7c517.svg";